module.exports = __webpack_public_path__ + "static/img/03.241f3c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/question/03.png
// module id = In2Y
// module chunks = 1